// DISHES page — three tabs: Мои блюда / База продуктов / Конструктор. Ported verbatim
// from the original app's DISHES, INGREDIENTS and RECIPE BUILDER sections.
import { S } from '../state.js';
import { save } from '../lib/sync.js';
import { n0, n1, uid, escHtml } from '../lib/format.js';
import { ingList, dishList } from '../lib/calc.js';
import { ING_BASE } from '../data/ingredients.js';
import { IC, cicon } from '../lib/icons.js';
import { openModal, closeModal } from '../lib/modal.js';
import { showConfirm } from '../components/confirmDialog.js';
import { showToast } from '../components/toast.js';
import { registerPage } from '../lib/router.js';

let dishTab = 'dishes';

export function switchDishTab(t) {
  dishTab = t;
  document.getElementById('dishTabDishes').classList.toggle('active', t === 'dishes');
  document.getElementById('dishTabIngs').classList.toggle('active', t === 'ings');
  document.getElementById('dishesPanel').style.display = t === 'dishes' ? '' : 'none';
  document.getElementById('ingsPanel').style.display = t === 'ings' ? '' : 'none';
  if (t === 'dishes') renderDishes();
  if (t === 'ings') renderIngs();
}

export function renderDishesPage() {
  if (dishTab === 'dishes') renderDishes();
  else if (dishTab === 'ings') renderIngs();
}
registerPage('dishes', renderDishesPage);

// ── DISHES ──
// Sort key applies after the search filter; 'fav' (default) keeps favorites pinned to the
// top the way it always did, everything else sorts by that macro, highest first — for
// "which of these has the most protein" type browsing.
function applySort(list, sortKey) {
  if (!sortKey || sortKey === 'fav') return list.sort((a, b) => (b.favorite ? 1 : 0) - (a.favorite ? 1 : 0));
  return list.sort((a, b) => (b[sortKey] || 0) - (a[sortKey] || 0));
}

export function renderDishes() {
  const q = (document.getElementById('dishSearch')?.value || '').toLowerCase();
  const sortKey = document.getElementById('dishSortSel')?.value || 'fav';
  const list = applySort(dishList().filter(d => !q || d.name.toLowerCase().includes(q)), sortKey);
  const el = document.getElementById('dishList');
  if (list.length === 0) {
    el.innerHTML = `<div class="empty"><div class="empty-icon">${cicon('meal', 28)}</div><div class="empty-text">Нет блюд</div></div>`;
    return;
  }
  el.innerHTML = list.map(d => `
    <div class="dish-item">
      <button class="dish-btn" onclick="toggleDishFavorite('${d.id}')" title="${d.favorite ? 'Убрать из избранного' : 'В избранное'}" style="color:${d.favorite ? 'var(--amber)' : 'var(--text3)'}">${d.favorite ? '★' : '☆'}</button>
      <div class="dish-body">
        <div class="dish-name">${escHtml(d.name)}</div>
        <div class="dish-meta">${d.k} ккал · Б ${d.p} · Ж ${d.f} · У ${d.c} / 100г</div>
        ${d.recipe ? `<div class="dish-meta" style="margin-top:2px;font-style:italic;white-space:nowrap;overflow:hidden;text-overflow:ellipsis">${escHtml(d.recipe.slice(0, 60))}${d.recipe.length > 60 ? '…' : ''}</div>` : ''}
      </div>
      <div class="dish-acts">
        <button class="dish-btn" onclick="editDish('${d.id}')" title="Редактировать">${IC.edit}</button>
        <button class="dish-btn" onclick="delDish('${d.id}')" title="Удалить">${IC.trash}</button>
      </div>
    </div>
  `).join('');
}

export function toggleDishFavorite(id) {
  const d = S.customDishes.find(x => x.id === id);
  if (!d) return;
  d.favorite = !d.favorite;
  save(true);
  renderDishes();
}

let dEditIngs = [];
let dIngSelected = null;
let dNoShrink = false;
// Stack of in-progress parent-dish edits, pushed when jumping into editing a nested
// component dish (dEditNestedDish) and popped back on save/cancel — see dEditNestedDish for
// why this exists instead of just re-populating the same fields destructively.
let dEditStack = [];

export function dIngSearch() {
  const q = document.getElementById('dIngInp').value.trim().toLowerCase();
  const sugg = document.getElementById('dIngSugg');
  if (q.length < 1) { sugg.style.display = 'none'; return; }
  // Dishes you already made are searchable here too (per-100g macros work the same way
  // as an ingredient) — so a dish like "тесto"/"фарш" can become a component of another
  // dish (e.g. "пельмени"), not just raw products.
  const list = [
    ...dishList().map(d => ({ name: d.name, k: d.k, p: d.p, f: d.f, c: d.c, src: 'блюдо' })),
    ...ingList().map(i => ({ name: i.name, k: i.k, p: i.p, f: i.f, c: i.c, src: 'продукт' })),
  ].filter(x => x.name.toLowerCase().includes(q)).slice(0, 8);
  if (!list.length) { sugg.style.display = 'none'; return; }
  sugg.innerHTML = list.map((x, i) => `
    <div class="sugg-item" onclick="dIngSelect(${i})">
      <div class="sugg-item-name">${escHtml(x.name)} <span style="font-size:10px;color:var(--text3)">${x.src}</span></div>
      <div class="sugg-item-meta">${x.k} ккал · Б ${x.p} · Ж ${x.f} · У ${x.c} / 100г</div>
    </div>`).join('');
  sugg._data = list;
  sugg.style.display = 'block';
}

export function dIngSelect(i) {
  const sugg = document.getElementById('dIngSugg');
  dIngSelected = sugg._data[i];
  document.getElementById('dIngInp').value = dIngSelected.name;
  sugg.style.display = 'none';
}

export function dIngAdd() {
  if (!dIngSelected) {
    const found = [...dishList(), ...ingList()].find(x => x.name === document.getElementById('dIngInp').value.trim());
    if (found) dIngSelected = found; else { showToast('Выбери продукт из списка'); return; }
  }
  const g = parseFloat(document.getElementById('dIngG').value) || 100;
  // If this component is itself one of your dishes (not a raw ingredient), remember which
  // one — so its row can be jump-edited (dEditNestedDish) and so saving that dish later can
  // push its fresh numbers back into this one automatically (see cascadeUpdateDish below).
  const sourceDish = dIngSelected.src === 'блюдо' ? dishList().find(d => d.name === dIngSelected.name) : null;
  dEditIngs.push({
    name: dIngSelected.name,
    per100: { k: dIngSelected.k, p: dIngSelected.p, f: dIngSelected.f, c: dIngSelected.c },
    grams: g,
    ...(sourceDish ? { isDish: true, dishId: sourceDish.id } : {}),
  });
  document.getElementById('dIngInp').value = '';
  document.getElementById('dIngG').value = '';
  dIngSelected = null;
  dRenderIngTable();
}

// Jump straight into editing a dish that's used as a component here (e.g. click "фарш"
// while composing "пельмени"). The modal is a single shared form, so it can't literally stack
// like food.js's version does — instead, whatever's currently in the form gets pushed onto
// dEditStack and restored (via dCloseModal, called from both Save and Cancel) once the nested
// dish's own edit is done, so nothing here gets lost or silently reverts to stale data.
export function dEditNestedDish(dishId) {
  if (!dishList().find(d => d.id === dishId)) return;
  dEditStack.push({
    id: document.getElementById('dEditId').value,
    title: document.getElementById('dishModalTitle').textContent,
    name: document.getElementById('dName').value,
    recipe: document.getElementById('dRecipe').value,
    cooked: document.getElementById('dCooked').value,
    noShrink: dNoShrink,
    ings: JSON.parse(JSON.stringify(dEditIngs)),
  });
  editDish(dishId, true);
}

function dRestoreSnapshot(snap) {
  dEditIngs = snap.ings;
  dIngSelected = null;
  document.getElementById('dishModalTitle').textContent = snap.title;
  document.getElementById('dName').value = snap.name;
  document.getElementById('dRecipe').value = snap.recipe;
  dNoShrink = snap.noShrink;
  document.getElementById('dNoShrinkChk').checked = dNoShrink;
  document.getElementById('dCooked').disabled = dNoShrink;
  document.getElementById('dCooked').style.opacity = dNoShrink ? '.6' : '';
  document.getElementById('dCooked').value = snap.cooked;
  document.getElementById('dEditId').value = snap.id;
  document.getElementById('dIngInp').value = '';
  document.getElementById('dIngG').value = '';
  document.getElementById('dIngSugg').style.display = 'none';
  dRenderIngTable(); // also refreshes any isDish row's per100, including the one just edited
}

// Close/Cancel for the dish modal — resumes the parent dish being edited if we're nested
// inside one (see dEditNestedDish), otherwise closes for real. Bound from the Cancel button
// instead of the generic closeModal() so cancelling out of a nested edit can't silently drop
// the parent's in-progress state.
export function dCloseModal() {
  if (dEditStack.length) dRestoreSnapshot(dEditStack.pop());
  else closeModal('shAddDish');
}

export function dDelIng(i) { dEditIngs.splice(i, 1); dRenderIngTable(); }
export function dSetIngGrams(i, val) { dEditIngs[i].grams = parseFloat(val) || 1; dCalcTotals(); }

function dRenderIngTable() {
  // A component dish (e.g. "фарш" inside "пельмени") may have been edited elsewhere since
  // this row was added/loaded — always pull its live per100 before displaying/totaling, on
  // top of the write-time cascade in cascadeUpdateDish(), so numbers never lag behind. Rows
  // saved before dish-tagging existed (or before a rename) won't carry isDish/dishId — fall
  // back to matching by name and backfill the tag.
  const editingId = document.getElementById('dEditId').value;
  dEditIngs.forEach(ing => {
    const src = (ing.dishId && dishList().find(x => x.id === ing.dishId))
      || dishList().find(x => x.name === ing.name && x.id !== editingId);
    if (!src) return;
    ing.per100 = { k: src.k, p: src.p, f: src.f, c: src.c };
    ing.isDish = true; ing.dishId = src.id;
  });
  const tbody = document.getElementById('dIngList');
  const foot = document.getElementById('dIngFoot');
  tbody.innerHTML = dEditIngs.map((ing, i) => {
    const k = n0(ing.per100.k * ing.grams / 100), p = n1(ing.per100.p * ing.grams / 100);
    const f = n1(ing.per100.f * ing.grams / 100), c = n1(ing.per100.c * ing.grams / 100);
    return `<tr style="border-bottom:1px solid var(--border)">
      <td style="padding:5px 4px;font-size:12px;white-space:nowrap">${ing.isDish ? `<button onclick="dEditNestedDish('${ing.dishId}')" class="dish-btn" style="padding:1px;vertical-align:middle" title="Открыть рецепт «${escHtml(ing.name)}»">${IC.edit}</button> ` : ''}${escHtml(ing.name)}</td>
      <td style="padding:3px 4px;text-align:right">
        <input type="number" value="${ing.grams}" min="1" style="width:54px;border:1.5px solid var(--border);border-radius:var(--r-xs);padding:3px 5px;font-size:12px;text-align:right;background:var(--surface);color:var(--text)"
          onchange="dSetIngGrams(${i},this.value)">
      </td>
      <td style="padding:5px 4px;text-align:right;color:var(--amber)">${k}</td>
      <td style="padding:5px 4px;text-align:right">${p}</td>
      <td style="padding:5px 4px;text-align:right">${f}</td>
      <td style="padding:5px 4px;text-align:right">${c}</td>
      <td style="padding:3px 2px;text-align:center"><button onclick="dDelIng(${i})" class="dish-btn">${IC.trash}</button></td>
    </tr>`;
  }).join('');
  foot.style.display = dEditIngs.length ? '' : 'none';
  dCalcTotals();
}

export function dCalcTotals() {
  if (!dEditIngs.length) return;
  let tk = 0, tp = 0, tf = 0, tc = 0, tg = 0;
  dEditIngs.forEach(ing => { const m = ing.grams / 100; tk += ing.per100.k * m; tp += ing.per100.p * m; tf += ing.per100.f * m; tc += ing.per100.c * m; tg += ing.grams; });
  document.getElementById('dTotalG').textContent = n0(tg);
  document.getElementById('dTotalK').textContent = n0(tk);
  document.getElementById('dTotalP').textContent = n1(tp);
  document.getElementById('dTotalF').textContent = n1(tf);
  document.getElementById('dTotalC').textContent = n1(tc);
  if (dNoShrink) document.getElementById('dCooked').value = n0(tg);
  const cooked = parseFloat(document.getElementById('dCooked').value) || 0;
  const row = document.getElementById('dPer100Row');
  if (cooked > 0) {
    const m = 100 / cooked;
    document.getElementById('dPer100K').textContent = n0(tk * m);
    document.getElementById('dPer100P').textContent = n1(tp * m);
    document.getElementById('dPer100F').textContent = n1(tf * m);
    document.getElementById('dPer100C').textContent = n1(tc * m);
    row.style.display = '';
  } else { row.style.display = 'none'; }
}

// "Считать сырым" — cooked weight = raw weight, no shrinkage during cooking (salads,
// fruit, anything you don't actually cook). Mirrors the same control in the per-meal Add
// Food sheet (fToggleNoShrink in pages/food.js) — same idea, same place it's defined for
// a dish now, not just re-guessed every time the dish gets logged (see PORT_STATUS notes
// on selectFoodItem preferring this over a heuristic).
export function dToggleNoShrink() {
  dNoShrink = document.getElementById('dNoShrinkChk').checked;
  const cookedInp = document.getElementById('dCooked');
  cookedInp.disabled = dNoShrink;
  cookedInp.style.opacity = dNoShrink ? '.6' : '';
  dCalcTotals();
}

export function openAddDish() {
  dEditStack = []; // fresh top-level open — any stale nested-edit context (e.g. left over from
  // closing via the modal backdrop instead of Cancel/Save) must not leak into this
  dEditIngs = []; dIngSelected = null;
  document.getElementById('dishModalTitle').textContent = 'Новое блюдо';
  document.getElementById('dName').value = '';
  document.getElementById('dRecipe').value = '';
  document.getElementById('dCooked').value = '';
  document.getElementById('dCooked').disabled = false;
  document.getElementById('dCooked').style.opacity = '';
  dNoShrink = false;
  document.getElementById('dNoShrinkChk').checked = false;
  document.getElementById('dEditId').value = '';
  document.getElementById('dIngInp').value = '';
  document.getElementById('dIngG').value = '';
  document.getElementById('dIngSugg').style.display = 'none';
  dRenderIngTable();
  openModal('shAddDish');
}

// `preserveStack` is only passed true internally by dEditNestedDish — every other caller
// (the dish list, or food.js jumping in from a food entry) is a genuine top-level open, so
// any stale nested-edit context left over from an irregular close (e.g. the modal backdrop)
// must not leak into it.
export function editDish(id, preserveStack) {
  const d = dishList().find(x => x.id === id);
  if (!d) return;
  if (!preserveStack) dEditStack = [];
  dEditIngs = (d.ingredients || []).map(i => ({ ...i, per100: { ...i.per100 } }));
  dIngSelected = null;
  document.getElementById('dishModalTitle').textContent = 'Редактировать блюдо';
  document.getElementById('dName').value = d.name;
  document.getElementById('dRecipe').value = d.recipe || '';
  dNoShrink = !!d.noShrink;
  document.getElementById('dNoShrinkChk').checked = dNoShrink;
  document.getElementById('dCooked').disabled = dNoShrink;
  document.getElementById('dCooked').style.opacity = dNoShrink ? '.6' : '';
  document.getElementById('dCooked').value = d.cookedWeight || '';
  document.getElementById('dEditId').value = id;
  document.getElementById('dIngInp').value = '';
  document.getElementById('dIngG').value = '';
  document.getElementById('dIngSugg').style.display = 'none';
  dRenderIngTable();
  openModal('shAddDish');
}

export function saveDish() {
  const id = document.getElementById('dEditId').value;
  const name = document.getElementById('dName').value.trim();
  if (!name) { showToast('Введи название'); return; }
  let k = 0, p = 0, f = 0, c = 0;
  const cooked = parseFloat(document.getElementById('dCooked').value) || 0;
  if (dEditIngs.length) {
    let tk = 0, tp = 0, tf = 0, tc = 0, tg = 0;
    dEditIngs.forEach(ing => { const m = ing.grams / 100; tk += ing.per100.k * m; tp += ing.per100.p * m; tf += ing.per100.f * m; tc += ing.per100.c * m; tg += ing.grams; });
    const per100m = cooked > 0 ? 100 / cooked : 100 / (tg || 100);
    k = n0(tk * per100m); p = n1(tp * per100m); f = n1(tf * per100m); c = n1(tc * per100m);
  }
  const dish = {
    id: id || uid(),
    name, k, p, f, c,
    recipe: document.getElementById('dRecipe').value.trim(),
    ingredients: dEditIngs.length ? JSON.parse(JSON.stringify(dEditIngs)) : [],
    cookedWeight: cooked || 0,
    noShrink: dNoShrink,
  };
  if (id) {
    const idx = S.customDishes.findIndex(d => d.id === id);
    if (idx >= 0) S.customDishes[idx] = dish;
  } else {
    S.customDishes.push(dish);
  }
  cascadeUpdateDish(dish);
  save(true);
  renderDishes();
  // If this save was for a dish nested inside another one still being edited, resume that
  // parent (with this dish's fresh numbers already picked up) instead of closing outright.
  if (dEditStack.length) dRestoreSnapshot(dEditStack.pop());
  else closeModal('shAddDish');
}

// A dish saved just now might be used as a component INSIDE other dishes (e.g. "фарш"
// inside "пельмени") — those components were stored as a snapshot (per100 at the time they
// were added), so editing "фарш" alone used to leave "пельмени" showing stale КБЖУ until
// someone happened to reopen and resave it. This walks every other dish, refreshes any row
// that references the just-saved one, recomputes THAT dish's own totals the same way
// saveDish() does, and recurses — so a multi-level chain stays in sync automatically.
// `visited` guards against an accidental circular reference (A contains B contains A). Rows
// saved before dish-tagging existed (or before a rename) won't carry isDish/dishId — matched
// by name as a fallback, and the tag gets backfilled so future edits go straight to the id.
function cascadeUpdateDish(changedDish, visited) {
  visited = visited || new Set([changedDish.id]);
  S.customDishes.forEach(parent => {
    if (visited.has(parent.id) || !parent.ingredients || !parent.ingredients.length) return;
    let touched = false;
    parent.ingredients.forEach(ing => {
      if ((ing.isDish && ing.dishId === changedDish.id) || (!ing.dishId && ing.name === changedDish.name)) {
        ing.per100 = { k: changedDish.k, p: changedDish.p, f: changedDish.f, c: changedDish.c };
        ing.isDish = true; ing.dishId = changedDish.id;
        touched = true;
      }
    });
    if (!touched) return;
    visited.add(parent.id);
    let tk = 0, tp = 0, tf = 0, tc = 0, tg = 0;
    parent.ingredients.forEach(ing => { const m = ing.grams / 100; tk += ing.per100.k * m; tp += ing.per100.p * m; tf += ing.per100.f * m; tc += ing.per100.c * m; tg += ing.grams; });
    const per100m = parent.cookedWeight > 0 ? 100 / parent.cookedWeight : 100 / (tg || 100);
    parent.k = n0(tk * per100m); parent.p = n1(tp * per100m); parent.f = n1(tf * per100m); parent.c = n1(tc * per100m);
    cascadeUpdateDish(parent, visited);
  });
}

export function delDish(id) {
  showConfirm('Удалить блюдо?', () => {
    S.customDishes = S.customDishes.filter(d => d.id !== id);
    save(true); renderDishes();
  });
}

document.addEventListener('click', e => {
  if (!e.target.closest('#dIngInp') && !e.target.closest('#dIngSugg'))
    document.getElementById('dIngSugg') && (document.getElementById('dIngSugg').style.display = 'none');
});

// ── INGREDIENTS (база продуктов) ──
export function renderIngs() {
  const q = (document.getElementById('ingSearch')?.value || '').toLowerCase();
  const sortKey = document.getElementById('ingSortSel')?.value || 'name';
  let list = ingList().filter(i => !q || i.name.toLowerCase().includes(q));
  list = sortKey === 'name'
    ? list.sort((a, b) => a.name.localeCompare(b.name, 'ru'))
    : list.sort((a, b) => (b[sortKey] || 0) - (a[sortKey] || 0));
  const el = document.getElementById('ingList');
  if (list.length === 0) {
    el.innerHTML = `<div class="empty"><div class="empty-text">Нет продуктов</div></div>`;
    return;
  }
  el.innerHTML = list.map((ing) => {
    const idx = ingList().indexOf(ing);
    const avail = S.ingAvailable[ing.name] !== false;
    return `<div class="ing-item">
      <label style="display:flex;align-items:center;gap:0;cursor:pointer;flex-shrink:0;margin-right:4px" title="${avail ? 'Есть дома' : 'Нет дома'}">
        <input type="checkbox" ${avail ? 'checked' : ''} style="width:16px;height:16px;accent-color:var(--accent);cursor:pointer" onchange="toggleIngAvail('${escHtml(ing.name)}',this.checked,this.closest('.ing-item'))">
      </label>
      <div class="ing-info" style="flex:1;min-width:0;${avail ? '' : 'opacity:.45'}">
        <div class="ing-name">${escHtml(ing.name)}</div>
        <div class="ing-kbzhu">${ing.k} ккал · Б ${ing.p} · Ж ${ing.f} · У ${ing.c} / 100г</div>
      </div>
      <div class="ing-acts">
        <button class="dish-btn" onclick="openEditIng(${idx})">${IC.edit}</button>
        <button class="dish-btn" onclick="delIng(${idx})">${IC.trash}</button>
      </div>
    </div>`;
  }).join('');
}

export function openAddIng() {
  document.getElementById('ingModalTitle').textContent = 'Новый продукт';
  document.getElementById('ingName').value = '';
  document.getElementById('ingK').value = '';
  document.getElementById('ingP').value = '';
  document.getElementById('ingF').value = '';
  document.getElementById('ingC').value = '';
  document.getElementById('ingEditIdx').value = '';
  openModal('shAddIng');
}

export function openEditIng(idx) {
  if (!S.customIngs) S.customIngs = JSON.parse(JSON.stringify(ING_BASE));
  const ing = S.customIngs[idx];
  document.getElementById('ingModalTitle').textContent = 'Редактировать';
  document.getElementById('ingName').value = ing.name;
  document.getElementById('ingK').value = ing.k;
  document.getElementById('ingP').value = ing.p;
  document.getElementById('ingF').value = ing.f;
  document.getElementById('ingC').value = ing.c;
  document.getElementById('ingEditIdx').value = idx;
  openModal('shAddIng');
}

export function saveIng() {
  const name = document.getElementById('ingName').value.trim();
  if (!name) return;
  const ing = {
    name,
    k: parseFloat(document.getElementById('ingK').value) || 0,
    p: parseFloat(document.getElementById('ingP').value) || 0,
    f: parseFloat(document.getElementById('ingF').value) || 0,
    c: parseFloat(document.getElementById('ingC').value) || 0,
  };
  if (!S.customIngs) S.customIngs = JSON.parse(JSON.stringify(ING_BASE));
  const idx = document.getElementById('ingEditIdx').value;
  if (idx !== '') {
    S.customIngs[parseInt(idx)] = ing;
  } else {
    S.customIngs.push(ing);
  }
  save(true); closeModal('shAddIng'); renderIngs();
}

export function delIng(idx) {
  showConfirm('Удалить продукт?', () => {
    if (!S.customIngs) S.customIngs = JSON.parse(JSON.stringify(ING_BASE));
    S.customIngs.splice(idx, 1);
    save(true); renderIngs();
  });
}

export function toggleIngAvail(name, val, rowEl) {
  S.ingAvailable[name] = val;
  save(true);
  if (rowEl) {
    const label = rowEl.querySelector('label');
    const info = rowEl.querySelector('.ing-info');
    if (label) label.title = val ? 'Есть дома' : 'Нет дома';
    if (info) info.style.opacity = val ? '' : '.45';
  }
}

